const groups = {
  '组合阀': ['ICF组合阀', 'ICF电磁阀', 'ICF EVRA组合电磁阀'],
  '电动阀与电磁阀': ['ICM电动阀', 'ICLX两步开启电磁阀', 'ICSH双位电磁阀', 'EVRA 电磁阀', 'AKV电子膨胀阀', 'CCMT电动调节阀'],
  '手动阀门': ['SVA手动截止阀', 'STC截止阀', 'REG调节阀', 'SCA、CHV止回阀', 'RNVA止回阀', 'FIA过滤器', 'FIASS不锈钢过滤器', 'QDV快速放油阀', 'OFV溢流阀'],
  '压力与液位调节': ['ICS伺服主阀', 'KDC排气压力控制阀', 'ORV油温调节阀', 'HFI高压浮球阀', 'SV浮球阀', 'SV4浮球阀', 'TEA热力膨胀阀'],
  '安全阀': ['SFA安全阀', 'SFV安全阀', 'DSV双座安全阀'],
  '控制系统': ['EKE347液位控制器', 'EKE400蒸发器控制器', 'ADAP-KOOL机组控制器', 'AKS4100液位传感器', 'LLS400液位开关', 'RT压力控制器', 'IRS自动空气分离器', '温度传感器', '压力传感器', '压力控制开关', '系列导阀'],
}

const actualFileNames = {
  'ICF组合阀': 'ICF组合阀.webp', 'ICF电磁阀': 'ICF电磁阀.webp', 'ICF EVRA组合电磁阀': 'ICF EVRA组合电磁阀.webp',
  'ICM电动阀': 'ICM电动阀.webp', 'ICLX两步开启电磁阀': 'ICLX两步开启电磁阀.webp', 'ICSH双位电磁阀': 'ICSH双位电磁阀.webp',
  'EVRA 电磁阀': 'EVRA 电磁阀.webp', 'AKV电子膨胀阀': 'akv电子膨胀阀.webp', 'CCMT电动调节阀': 'ccmt电动调节阀.webp',
  'AKS4100液位传感器': 'aks4100液位传感器.webp', 'ADAP-KOOL机组控制器': 'ADAP-KOOL机组控制器.webp',
}

let productId = 0

export const productGroups = Object.entries(groups).map(([category, names]) => ({
  category,
  products: names.map((name) => ({ id: ++productId, name, category, image: `/产品图片/${actualFileNames[name] || `${name}.webp`}` })),
}))

export const allProducts = productGroups.flatMap((group) => group.products)
export const featuredProducts = allProducts.slice(0, 8)
